import { Component, OnInit } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute } from '@angular/router';
import { SeoService } from '../../../core/seo.service';
import { NavbarService } from '../../../core/navbar.service';

@Component({
  selector: 'app-membership-details',
  templateUrl: './membership-details.component.html',
  styleUrls: ['./membership-details.component.css']
})
export class MembershipDetailsComponent implements OnInit {

  memberForm: FormGroup;
  loading = false;
  success = false;

  membershipTiers: { [key: string]: string } = {
    'student-vet-senior': 'Student / Veteran / Senior ($20/year)',
    'individual': 'Individual ($30/year)',
    'family': 'Family ($50/year)',
    'patron': 'Patron Supporter ($500/year)',
    'benefactor': 'Benefactor Circle ($2,000/year)'
  };

  submittedData = {
    name: '',
    email: '',
    tierName: ''
  };

  constructor(
    private fb: FormBuilder,
    private afs: AngularFirestore,
    private route: ActivatedRoute,
    private seo: SeoService,
    public nav: NavbarService
  ) { }

  ngOnInit() {
    this.nav.show();
    this.seo.updateTags({
      title: 'Become a Member - Membership Application',
      description: 'Apply to become a Bayou Lacombe Museum member. Support historical preservation, school tours, and community heritage.',
      url: '/memberships/become-a-member'
    });

    const preselectedTier = this.route.snapshot.queryParamMap.get('tier') || 'family';

    this.memberForm = this.fb.group({
      name: ['', [
        Validators.required,
        Validators.pattern('[a-zA-Z .-]*'),
      ]],
      email: ['', [
        Validators.required,
        Validators.email
      ]],
      membership: [preselectedTier, [
        Validators.required
      ]]
    });
  }

  get name() {
    return this.memberForm.get('name');
  }

  get email() {
    return this.memberForm.get('email');
  }

  get member() {
    return this.memberForm.get('membership');
  }

  get mailtoLink(): string {
    const tier = this.submittedData.tierName || this.membershipTiers[this.memberForm.value.membership] || 'Membership';
    const applicantName = this.submittedData.name || this.memberForm.value.name || '';
    const applicantEmail = this.submittedData.email || this.memberForm.value.email || '';
    const subject = encodeURIComponent(`Bayou Lacombe Museum Membership Application - ${tier}`);
    const body = encodeURIComponent(
      `Hello Bayou Lacombe Museum,\n\nI have submitted my membership application with the following details:\n\nName: ${applicantName}\nEmail: ${applicantEmail}\nSelected Tier: ${tier}\n\nPlease let me know how to complete payment and when to expect my membership packet!\n\nThank you,\n${applicantName}`
    );
    return `mailto:bayoulacombemuseum@gmail.com,info@bayoulacombemuseum.com?subject=${subject}&body=${body}`;
  }

  async onSubmit() {
    if (this.memberForm.invalid) return;

    this.loading = true;
    const tierKey = this.memberForm.value.membership;
    const tierName = this.membershipTiers[tierKey] || tierKey;

    const formValue = {
      name: this.memberForm.value.name,
      email: this.memberForm.value.email,
      membership: tierKey,
      membershipLabel: tierName,
      createdAt: new Date()
    };

    this.submittedData = {
      name: this.memberForm.value.name,
      email: this.memberForm.value.email,
      tierName: tierName
    };

    try {
      await this.afs.collection('member').add(formValue);
      this.success = true;
    } catch (err) {
      console.error('Firestore submission note:', err);
      // Even if Firestore offline, allow user to continue
      this.success = true;
    } finally {
      this.loading = false;
    }
  }
}

